import FutureSightTag from './FutureSightTag';
import schema from './props-schema';

FutureSightTag.schema = schema;

// https://github.com/webpack/webpack/issues/706
export default FutureSightTag;
